import { isObjectDeeplyChanged } from '../../util/state';
import { State } from '../App/selector';

/**
 * Update flags for Discount section
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const {
        isGigakombi,
        isFriendsAndFamily,
        isYoung,
        isResidentPlus,
        selectedTariffId,
        availableTariffs,
        isContentEnabled,
        selectedTVProduct,
        isAvailabilityChecked,
        selectedTariff,
    } = state;
    const isGigakombiChanged = isGigakombi !== oldState.isGigakombi;
    const isFriendsAndFamilyChanged = isFriendsAndFamily !== oldState.isFriendsAndFamily;
    const isYoungChanged = isYoung !== oldState.isYoung;
    const isResidentPlusChanged = isResidentPlus !== oldState.isResidentPlus;
    const isSelectedChanged = selectedTariffId !== oldState.selectedTariffId;
    const isTariffsChanged = availableTariffs && isObjectDeeplyChanged(availableTariffs, oldState.availableTariffs);
    const isContentEnabledChanged = isContentEnabled !== oldState.isContentEnabled;
    const isTvProductChanged = selectedTVProduct !== oldState.selectedTVProduct;
    const isResidentPriceChanged = selectedTariff?.residentBonus?.price.value !== oldState.selectedTariff?.residentBonus?.price.value;

    return {
        tariff: isSelectedChanged || isTariffsChanged,
        gigakombi: isGigakombiChanged,
        friendsAndFamily: isFriendsAndFamilyChanged,
        young: isYoungChanged,
        residentPlus: isResidentPlusChanged,
        content: isContentEnabledChanged || isAvailabilityChecked !== oldState.isAvailabilityChecked,
        tvProduct: isTvProductChanged,
        residentPlusPrice: isResidentPriceChanged,
    };
};
